import React, { useRef, useState } from 'react';
import { Helmet } from 'react-helmet'; // Added for SEO
import './homepage.css'; // Assuming your styles are in this file

import vision from "../../image/vission1.png";
import missionn from "../../image/missionn.png";
import mission from "../../image/mission.png";
import teamMember1 from "../../image/IMG_0765.png"; // Replace with team member image
import teamMember2 from "../../image/Rakesh.png"; // Replace with team member image
import emailjs from 'emailjs-com';
import Carousel from '../Carousel/Carousel';
import Landingsection from '../Landingsection/Landingsection';
import aboutt from '../../image/aboutt.png';
import ContactUs from '../ContactUs/ContactUs';
import GoogleTranslate from '../GoogleTranslate/GoogleTranslate';
import contact from '../../image/contactus1.jpg';

const Homepage = () => {

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_zdzy7uj', 'template_gxsbntx', form.current, 'rom8gSkgP8Q-KXpqA')
            .then(
                (result) => {
                    console.log('SUCCESS!', result.text);
                    alert('Message sent successfully!');
                },
                (error) => {
                    console.error('FAILED...', error.text);
                    alert('Message failed to send.');
                }
            );
    };

    return (
        <div>
            {/* SEO Tags */}
            <Helmet>
                <title>Paper Mill Machine Manufacturers in Gujarat, India - Paper and Board Machinery in India</title>
                <meta
                    name="description"
                    content="Paper Mill Machine Manufacturers in Gujarat, India. Paper and Board Machinery in India. P. Rakesh Industries is a leading paper machine and kraft paper mill machinery manufacturer in Gujarat, India, offering high-quality paper and board machines, coating machines, duplex board lines, and OEM spare parts. Trusted by 200+ clients for reliability, precision engineering, and timely service."
                />
                <meta property="og:title" content="Paper Mill Machine Manufacturers in Gujarat, India - Paper and Board Machinery in India" />
                <meta
                    property="og:description"
                    content="Paper Mill Machine Manufacturers in Gujarat, India. Paper and Board Machinery in India. P. Rakesh Industries is a leading paper machine and kraft paper mill machinery manufacturer in Gujarat, India, offering high-quality paper and board machines, coating machines, duplex board lines, and OEM spare parts. Trusted by 200+ clients for reliability, precision engineering, and timely service."
                />
                    <meta property="og:url" content="https://pripapermachines.com/" />
                   <link rel="canonical" href="https://pripapermachines.com/" />
            </Helmet>

            <Landingsection />

            {/* Landing Page Section */}
            {/* <div className="landing-page">
                <div className="overlay">
                    <div className="text-container">
                        <h1>PAPER AND BOARD MACHINES</h1>
                        <h1>linking the BIG</h1>
                    </div>
                </div>
            </div> */}

            {/* <div class="feature-section">
                <div class="feature-item">
                    <div class="feature-circle">200+ Clients</div>
                </div>
                <div class="feature-item">
                    <div class="feature-circle">Quality Assurance</div>
                </div>
                <div class="feature-item">
                    <div class="feature-circle">Ethical Trading Values</div>
                </div>
                <div class="feature-item">
                    <div class="feature-circle">Timely Shipment</div>
                </div>
                <div class="feature-item">
                    <div class="feature-circle">Affordable Price</div>
                </div>
            </div> */}

            {/* <GoogleTranslate/> */}

            <section className="do_section layout_padding" style={{ marginTop: "70px" }}>
                <div className="container">
                    <div className="do_container">
                        <div className="box arrow-start arrow_bg">
                            <div className="img-box">
                                <span>200+</span><span>Clients</span>
                            </div>
                        </div>
                        <div className="box arrow-middle arrow_bg">
                            <div className="img-box">
                                <span>Quality</span><span>Assurance</span>
                            </div>
                        </div>
                        <div className="box arrow-middle arrow_bg">
                            <div className="img-box">
                                <span>Ethical</span><span>Trading</span><span>Values</span>
                            </div>
                        </div>
                        <div className="box arrow-end arrow_bg">
                            <div className="img-box">
                                <span>Timely</span><span>Shipment</span>
                            </div>
                        </div>
                        <div className="box">
                            <div className="img-box">
                                <span>Affordable</span><span>Price</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div style={{ marginTop: "110px" }}>
                <Carousel />
            </div>

            <div className="divider" />

            {/* About Us Section */}
            <div className='viewwww'>
                <div className="about-container" id='about'>
                    <div className="about-text">
                        <h1 style={{ color: "black" }}>About Us</h1>
                        <p style={{ color: "black", textAlign: "justify" }}>
                            For more than 25 years, we, P. Rakesh Industries have been serving the paper industry with all our dedication and focus. Our company has been receiving immense appreciation for making available the best range of Pressure Former, Cylinder Mould, Spiderless Cylinder Mould, R F Vat, Blade Coater, Bar Coater, Extractor Press, Size Press, Coating Disperser, Roll Cleaner, etc. These products are acknowledged by customers owing to their incomparable quality. Our quality creations are available at market leading prices that highly suit the budgets of our clients. We have been able to fulfil bulk orders in minimum time owing to our great infrastructural facilities. Along with the quality, we also focus on the other aspects of services like accurate packaging as well as timely shipment.
                            <br /><br />
                            As our company has the support of greatly experienced and diligent workers, it has been witnessing constant growth. The biggest credit for our enormous success goes to our team members that includes manufacturers, quality controllers, packaging personnel, warehousing experts and sales & marketing executives. All of them give their best to complete each job assigned to them with perfection. Because of the efficiency of our members, we have been able to make promises and always keep them.
                        </p>
                    </div>

                    <div className="about-image">
                        <img src={aboutt} alt="About Us - Factory" style={{ marginTop: "70px" }} />
                    </div>
                </div>
            </div>

            <div className="divider" />

            {/* Mission Section */}
            <div className='desktopresp'>
                <div className="about-container">
                    <div className="about-image">
                        <img src={missionn} alt="Vision" />
                    </div>
                    <div className="about-text" style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                        <h1 style={{ color: "black", marginBottom: "10px", marginTop: "-15px" }}>Mission</h1>
                        <p style={{ color: "black", textAlign: "justify" }}>
                            As a family-owned company, our mission is clear: P.Rakesh Industries is personal and flexible. Our dedicated team is available to solve the smallest queries of our clients. Having worked for leading companies across the country as well as abroad, we understand the challenges faced.
                        </p>
                    </div>
                </div>
            </div>

            <div className="mobileresponsive">
                <div className="about-container">
                    <div className="about-text" style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                        <h1 style={{ color: "black", marginBottom: "10px" }}>Mission</h1>
                        <p style={{ color: "black", textAlign: "justify" }}>
                            As a family-owned company, our mission is clear: P.Rakesh Industries is personal and flexible. Our dedicated team is available to solve the smallest queries of our clients. Having worked for leading companies across the country as well as abroad, we understand the challenges faced.
                        </p>
                    </div>
                    <div className="about-image">
                        <img src={mission} alt="Mission" />
                    </div>
                </div>
            </div>

            <div className="divider" />

            {/* Vision Section */}
            <div>
                <div className="about-container">
                    <div className="about-text" style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                        <h2 style={{ color: "black", marginBottom: "10px", marginTop: "-15px" }}>Vision</h2>
                        <p style={{ color: "black", textAlign: "justify" }}>
                            Our vision is to widen the company's network and cover more major markets across the globe. We are giving our best to expand the clientele of our enterprise by attracting more customers. Soon, we will be transforming all our dreams into reality with the support of our passionate team members.
                        </p>
                    </div>
                    <div className="about-image">
                        <img src={vision} alt="Vision" />
                    </div>
                </div>
            </div>

            <div className="divider" />

            {/* Why Choose Us */}
            <div className="why-choose-section">
                <h1>Why Choose P. Rakesh Industries?</h1>
                <div className="features">
                    <div className="feature">
                        <h1>Expertise</h1>
                        <p>
                            Our team comprises seasoned professionals with extensive experience in paper mill machinery,
                            ensuring that we deliver tailored solutions to meet your operational requirements.
                        </p>
                    </div>
                    <div className="feature">
                        <h1>Quality Assurance</h1>
                        <p>
                            We supply only genuine, high-performance parts, and our services adhere to strict quality
                            control standards to maximize machinery uptime.
                        </p>
                    </div>
                    <div className="feature">
                        <h1>Rapid Response</h1>
                        <p>
                            Our streamlined logistics and service processes ensure swift delivery of parts and services,
                            minimizing production disruptions.
                        </p>
                    </div>
                </div>
            </div>

            <div className="divider" />

            {/* Founders */}
            <section>
                <h1 className="founder-heading">Founders</h1>
                <div className="founder-container">
                    <div className="founder-card">
                        <img src={teamMember1} alt="Founder 1" className="founder-image" />
                        <h1>Paresh Bharatia</h1>
                        <p>Co-Founder</p>
                    </div>
                    <div className="founder-card">
                        <img src={teamMember2} alt="Founder 2" className="founder-image" />
                        <h1>Rakesh Bharatia</h1>
                        <p>Co-Founder</p>
                    </div>
                </div>
            </section>

            <div className="divider" />

            {/* Contact Section */}
            <div style={{ marginTop: "70px" }}>
                <div className='contactrespdesk'>
                    <div className="about-container">
                        <div className="about-image">
                            <img src={contact} alt="Contact" />
                        </div>
                        <div className="about-text" style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                            <iframe
                                src="https://docs.google.com/forms/d/e/1FAIpQLSex_GdhK0PdKUPPMicNSgqS0SXrMUmtcv9qIs6z53ZEKvsOUA/viewform?embedded=true"
                                width="95%"
                                height="350px"
                                style={{ border: "none" }}
                            >
                                Loading…
                            </iframe>
                        </div>
                    </div>
                </div>

                <div className="contactresp">
                    <div className="about-container">
                        <div className="about-text" style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                            <iframe
                                src="https://docs.google.com/forms/d/e/1FAIpQLSex_GdhK0PdKUPPMicNSgqS0SXrMUmtcv9qIs6z53ZEKvsOUA/viewform?embedded=true"
                                width="95%"
                                height="350px"
                                style={{ border: "none" }}
                            >
                                Loading…
                            </iframe>
                        </div>
                        <div className="about-image">
                            <img src={contact} alt="Contact" />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Homepage;
